import styled from 'foundations-theming/utils';
const HR = styled.hr.withConfig({
  displayName: "HR"
})(({
  theme
}) => ({
  backgroundColor: theme.color['border-core-default'],
  border: 0,
  height: '1px',
  marginTop: theme.space[400],
  marginBottom: theme.space[400]
}));
export default HR;